import { FETCH_SERVICE_LIST } from "../actionTypes";
import { fetchServiceList } from "../../../api/incidentManagement/serviceList.service";

const serviceListRequest = ()=>({type: FETCH_SERVICE_LIST.REQUEST})
const serviceListFailure = (error)=>({type: FETCH_SERVICE_LIST.FAILURE, error})
const serviceListSuccess = (obj)=>({type: FETCH_SERVICE_LIST.SUCCESS, obj})


export const getServiceList = (next=null,status,uniqueCustomerRefId,orderBy,searchKeyValue="")=>{
    return (dispatch, getState)=>{        
        dispatch(serviceListRequest())
        return fetchServiceList(next,status,uniqueCustomerRefId,orderBy,searchKeyValue)
        .then(response => {         
            let obj={
                'data':response.data,
                'next':response.next,
                "isLoadMore": next?true:false,
                'statusCount':response?.statusCount
            }    
            dispatch(serviceListSuccess(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(serviceListFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}